/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

//START: Platform Type <editor-fold desc="Platform Type">
/**
 * **Platform Type:** Unknown/Default
 * @type {(0)}
 * @static
 * @readonly
 * @deprecated Use 'Feature Detection' instead
 */
const UNKNOWN = 0;

/**
 * **Platform Type:** REACH Player
 * @type {(1)}
 * @static
 * @readonly
 * @deprecated Use 'Feature Detection' instead
 */
const REACH_PLAYER = 1;

/**
 * **Platform Type:** BrightSign
 * @type {(2)}
 * @static
 * @readonly
 * @deprecated Use 'Feature Detection' instead
 */
const BRIGHTSIGN = 2;

/**
 * **Platform Type:** Preview Player
 * @type {(3)}
 * @static
 * @readonly
 * @deprecated Use 'Feature Detection' instead
 */
const PREVIEW_PLAYER = 3;

/**
 * **Platform Type:** Touchscreen
 * @type {(4)}
 * @static
 * @readonly
 * @deprecated Use 'Feature Detection' instead
 */
const TOUCHSCREEN = 4;

/**
 * **Platform Type:** Screen Saver
 * @type {(5)}
 * @static
 * @readonly
 * @deprecated Use 'Feature Detection' instead
 */
const SCREEN_SAVER = 5;

/**
 * **Platform Type:** Amazon FireOS
 * @type {(6)}
 * @static
 * @readonly
 * @deprecated Use 'Feature Detection' instead
 */
const FIRE_OS = 6;

/**
 * **Platform Type:** Chrome Extension
 * @type {(7)}
 * @static
 * @readonly
 * @deprecated Use 'Feature Detection' instead
 */
const CHROME_EXTENSION = 7;

/**
 * **Platform Type:** WebOS
 * @type {(8)}
 * @static
 * @readonly
 * @deprecated Use 'Feature Detection' instead
 */
const WEBOS = 8;

/**
 * **Platform Type:** PWA
 * @type {(9)}
 * @static
 * @readonly
 * @deprecated Use 'Feature Detection' instead
 */
const PWA = 9;
//END: Platform Type </editor-fold desc="Platform Type">

/**
 * Compare version strings
 *
 * - returns `-1` if `v1` is less than `v2`
 * - returns  `0` if `v1` is equal to `v2`
 * - returns  `1` if `v1` is greater than `v2`
 * @param {string} v1
 * @param {string} v2
 * @returns {number}
 * @static
 * @todo move to utility
 */
function versionCompare(v1, v2) {
    var v1Parts = v1.split('.');
    var v2Parts = v2.split('.');
    var maxLength = Math.max(v1Parts.length, v2Parts.length);

    for (var i = 0; i < maxLength; i++) {
        // `parseInt()` will ignore anything after the first non-numeric
        // character
        var v1Part = parseInt(v1Parts[i] || 0, 10);
        var v2Part = parseInt(v2Parts[i] || 0, 10);

        if (v1Part === v2Part) {
            continue;
        } else if (v1Part > v2Part) {
            return 1;
        } else {
            return -1;
        }
    }

    return 0;
}

export {
    UNKNOWN,
    REACH_PLAYER,
    BRIGHTSIGN,
    PREVIEW_PLAYER,
    TOUCHSCREEN,
    SCREEN_SAVER,
    FIRE_OS,
    CHROME_EXTENSION,
    WEBOS,
    PWA,
    versionCompare,
};
